<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      出库管理
      <small>/ 库存列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">保证金管理列表</h4>
              </div>
              <!-- end panel-heading -->
              <div class="panel-body">
                <form style="margin-top:16px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">品牌名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="BrandList"
                          key-field="brandId"
                          show-field="brandName"
                          placeholder="品牌名称"
                          v-model="brandId"
                          @values="BrandChange"
                          title
                        ></v-selectpage>
                      </div>
                      <label class="col-md-1 col-form-label">系列名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="SeriesList"
                          key-field="seriesId"
                          show-field="seriesName"
                          placeholder="系列名称"
                          v-model="seriesId"
                          title
                        ></v-selectpage>
                      </div>
                       <label class="col-md-1 col-form-label">服务商名称</label>
                      <div class="col-md-2">
                        <el-select
                          v-model="recomId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="服务商名称"
                        >
                          <el-option
                            v-for="item in recomList"
                            :key="item.recomId"
                            :label="item.recomName"
                            :value="item.recomId"
                          ></el-option>
                        </el-select>
                      </div>
                       <div class="col-md-3"></div>
                      <label class="col-md-1 col-form-label LineSpacing">商品名称</label>
                      <div class="col-md-2 LineSpacing">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="商品名称"
                          v-model="goodsName"
                        >
                      </div>
                      <!-- <label class="col-md-1 col-form-label">企业名称</label>
                      <div class="col-md-2">
                        <el-select 
                          style="width:100%;"
                          clearable 
                          placeholder="企业名称" 
                          v-model="companyId"
                        >
                          <el-option
                            v-for="item in companyList"
                            :key="item.id"
                            :label="item.commerceName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">时间</label>
                      <div class="col-md-3 LineSpacing">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                        ></el-date-picker>
                      </div> -->
                      <div class="col-md-1 LineSpacing">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                        >查询</a>
                      </div>
                      <div class="col-md-8"></div>
                      <div class="col-md-11"></div>
                      <div class="col-md-1">
                        <a class="btn btn-primary ButtonColor m-r-5" @click="ExportClick()">导出</a>
                      </div>
                    </div>
                  </fieldset>
                </form>
                <el-table :data="tableData" style="width: 100%" border>
                  <el-table-column
                    width="50"
                    prop="ordernumber"
                    label="序号"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="brandName"
                    label="品牌"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="seriesName"
                    label="系列"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="goodsName"
                    label="商品名称"
                    align="center"
                    width="400"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="recomName"
                    label="服务商名称"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="lockreserve"
                    label="锁定库存"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="reserve"
                    label="剩余库存"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="inputTime"
                    label="下单时间"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10,20,50,100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "store",
  data() {
    return {
      BrandList: [],
      SeriesList: [],
      pageSize: 10,
      totalCount: 0,
      recomList:[],
      recomId:'',
      pageindex: 1,
      startTime: "",
      endTime: "",
      companyList: [],
      tableData: [],
      director:0,
      TimeValue:'',
      brandId:'',
      seriesId:'',
      companyId:'',
      goodsName:''
    };
  },
  created() {
    this.initdata();
    this.getBrandInfo();
    this.getCompanyList();
      this.getRecomList();
  },
    mounted() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    SearchClick() {
      this.pageNo = 1;
      this.initdata();
    },
    initdata() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOutController/queryOutGoodsInfo",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          director: that.director,
          brandId: that.brandId,
          seriesId: that.seriesId,
          goodsName: that.goodsName,
          recomId: that.recomId,
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.tableData = response.data.data.result;
          that.totalCount = response.data.data.total;
          for (var i in response.data.data.result) {
            response.data.data.result[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
          }
        } else {
          http.handleHttpError(error, that);
        }
      })
      .catch(function(error) {
        http.handleHttpError(error, that);
      });
    },
     // 获取服务商列表
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.recomList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    getCompanyList() {
      let that = this;
      const options = {
        url: "/distribution/B2cOrderInfoController/parsingUserTob",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.companyList = response.data.data.result;
        } else {
          http.handleHttpError(error, that);
        }
      })
      .catch(function(error) {
        http.handleHttpError(error, that);
      });
    },
    getBrandInfo() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.BrandList = response.data.data.brandList;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    BrandChange(val) {
      if (val.length !== 0) {
        let that = this;
        const options = {
          url: "distribution/B2cGoodsInfoController/cascadeQuery",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            brandId: that.brandId
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.SeriesList = response.data.data;
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      } else {
        this.brandId = "";
        this.seriesId = "";
        this.SeriesList = [];
      }
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
         //   保证金列表导出
/**/
 ExportClick() {
      let that = this;
        if(that.depositStatus != null && that.depositStatus != '' &&  that.depositStatus != 'undefined'){
        that.depositStatusList = that.depositStatus
      }
      const options = {
        url: "distribution/B2cTobOutController/exportOutGoodsList",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
         director: that.director,
          brandId: that.brandId,
          seriesId: that.seriesId,
          goodsName: that.goodsName,
          recomId: that.recomId,
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
          } else {
            that.ExportClickSecond();
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    ExportClickSecond() {
      let   that  = this
        if(that.depositStatus != null && that.depositStatus != '' &&  that.depositStatus != 'undefined'){
        that.depositStatusList = that.depositStatus
      }
      const options = {
        url: "distribution/B2cTobOutController/exportOutGoodsList",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director,
          brandId: that.brandId,
          seriesId: that.seriesId,
          goodsName: that.goodsName,
          recomId: that.recomId,
        }),
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          var filename = "库存列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.left {
  margin-left: 20px;
}
.upload {
  margin-top: 20px;
  margin-left: 13%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  /* margin-top: 50px; */
  padding-right: 30px;
  letter-spacing: 1px;
}
.a_class {
  padding: 8px 12px;
}
/*  */
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/store.vue